import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCurrentSession } from "../../services/auth";

const API_URL = (
  process.env.REACT_APP_API_URL || "https://zedro-backend.onrender.com"
).replace(/\/$/, "");

export default function ProductsList() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    async function loadProducts() {
      try {
        setLoading(true);

        const session = getCurrentSession();
        const token = session?.token;

        const res = await fetch(`${API_URL}/api/admin/products`, {
          headers: token
            ? {
                Authorization: `Bearer ${token}`,
              }
            : {},
        });

        const data = await res.json().catch(() => ({}));

        if (!res.ok) {
          throw new Error(data?.error || "cannot_load_products");
        }

        if (alive) {
          setProducts(data.products || []);
        }
      } catch (err) {
        console.error("[ADMIN] cannot_load_products", err);

        if (alive) {
          setProducts([]);
        }
      } finally {
        if (alive) {
          setLoading(false);
        }
      }
    }

    loadProducts();

    return () => {
      alive = false;
    };
  }, []);

  if (loading) return <div>Cargando productos...</div>;

  return (
    <main
      style={{
        maxWidth: 1000,
        margin: "2rem auto",
        fontFamily: "Questrial, sans-serif",
      }}
    >
      {/* Header */}
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "1rem",
          marginBottom: "1.5rem",
          flexWrap: "wrap",
        }}
      >
        {/* Lado izquierdo */}
        <div>
          <div
            style={{
              fontSize: 12,
              letterSpacing: ".16em",
              textTransform: "uppercase",
              color: "rgba(44,59,81,.55)",
              fontWeight: 800,
              marginBottom: 6,
            }}
          >
            Admin Central
          </div>

          <h1
            style={{
              margin: 0,
              fontFamily: "Bitter, serif",
              fontSize: 28,
              color: "#0a2230",
              fontWeight: 800,
            }}
          >
            Productos
          </h1>

          <p
            style={{
              margin: "0.35rem 0 0",
              color: "#6b7a88",
              fontSize: "0.95rem",
              lineHeight: 1.5,
              maxWidth: 760,
            }}
          >
            Gestión de productos comerciales y accesos.
          </p>
        </div>

        {/* Lado derecho */}
        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          <Link
            to="/admin"
            style={{
              textDecoration: "none",
              color: "rgba(44,59,81,.65)",
              fontWeight: 600,
              fontSize: "0.9rem",
            }}
          >
            ← Admin Central
          </Link>

          <Link
            to="/admin/productos/nuevo"
            style={{
              background: "#264763",
              color: "#fff",
              padding: "10px 18px",
              borderRadius: 10,
              fontWeight: 700,
              textDecoration: "none",
            }}
          >
            + Crear Producto
          </Link>
        </div>
      </header>

      {/* Grid Productos */}
      <section
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: 14,
        }}
      >
        {products.map((p) => (
          <Link
            key={p.id}
            to={`/admin/productos/${p.id}`}
            style={{
              border: "1px solid #e6ebf1",
              borderRadius: 14,
              padding: "16px",
              background: "#fff",
              textDecoration: "none",
              boxShadow: "0 10px 30px rgba(0,0,0,.05)",
              color: "inherit",
              display: "block",
              maxWidth: 420,
            }}
          >
            <div style={{ fontWeight: 900, color: "#0a2230", fontSize: 18 }}>
              {p.name}
            </div>

            <div style={{ marginTop: 8, display: "flex", gap: 8, flexWrap: "wrap" }}>
              <span
                style={{
                  border: "1px solid #e6ebf1",
                  background: "#fafafa",
                  padding: "6px 10px",
                  borderRadius: 999,
                  fontSize: "0.8rem",
                  fontWeight: 700,
                }}
              >
                {p.product_type}
              </span>

              <span
                style={{
                  border: "1px solid #e6ebf1",
                  background: "#fff",
                  padding: "6px 10px",
                  borderRadius: 999,
                  fontSize: "0.8rem",
                  fontWeight: 700,
                  color: "#6b7a88",
                }}
              >
                {p.status}
              </span>

              <span
                style={{
                  border: "1px solid #e6ebf1",
                  background: p.is_active ? "#e8f5e9" : "#fff",
                  padding: "6px 10px",
                  borderRadius: 999,
                  fontSize: "0.8rem",
                  fontWeight: 700,
                  color: p.is_active ? "#2e7d32" : "#6b7a88",
                }}
              >
                {p.is_active ? "Activo" : "Inactivo"}
              </span>
            </div>
          </Link>
        ))}
      </section>
    </main>
  );
}